<template>
  <v-card>
    <v-btn
      dark
      absolute
      fixed
      bottom
      large
      right
      fab
      color="primary"
      class="mr-4 mb-16 fabNav"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Pays
      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>
    <v-card-text>
      <v-list>
        <v-list-item v-for="item in Countries" :key="item.iso" class="project">
          <v-list-item-content>
            <v-list-item-title v-html="item.name"></v-list-item-title>
            <v-list-item-subtitle v-html="item.iso"></v-list-item-subtitle>
          </v-list-item-content>

          <!--  <v-list-item-icon>
            <v-btn icon @click="addProjet(item)">
              <v-icon>add_circle</v-icon>
            </v-btn>

            <v-btn icon @click="deleteBailleur(item)">
              <v-icon>delete</v-icon>
            </v-btn>
            <v-btn icon @click="openDialog(item)">
              <v-icon>edit</v-icon>
            </v-btn>

            <v-btn icon @click="detailsBailleur(item)">
              <v-icon>chevron_right</v-icon>
            </v-btn>
          </v-list-item-icon> -->
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-card-actions>
      <div class="text-center">
        <v-btn
          class="primary"
          @click="prevPage()"
          :disabled="disable_prev || !(pagination_clicked_count > 0)"
          >Précédent</v-btn
        >
        <v-btn class="mx-3" fab color="primary">{{
          pagination_clicked_count + 1
        }}</v-btn>
        <v-btn class="primary" @click="nextPage" :disabled="disable_next"
          >Suivant</v-btn
        >
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    //this.importCountriesOnce();
    this.GetCountries();
  },
  computed: {
    ...mapState({
      Countries: (state) => state.Countries.Countries,
      pagination_clicked_count: (state) =>
        state.Countries.pagination_clicked_count,
      disable_next: (state) => state.Countries.disable_next,
      disable_prev: (state) => state.Countries.disable_prev,
    }),
  },
  methods: {
    /*   importCountriesOnce() {
      var self = this;
      let jsonFilePath = require("../../../countries.json");
      Object.keys(jsonFilePath).forEach(function (item) {
        var elem = item;
        self.$firebase
          .firestore()
          .collection("countries")
          .doc(item)
          .set(jsonFilePath[item]);
      });
      console.log("vita ny Country");
    }, */
    ...mapActions({
      GetCountries: "Countries/Get",
      prevPage: "Countries/prevPage",
      nextPage: "Countries/nextPage",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
